export default __webpack_public_path__ + "static/media/twitter-logo.8097ca9d.svg";